import { apiRequest } from "./apiClient";
import { resolveCategoryId } from "./tcg";
import { apiErrorCode } from "../i18n/errorMessages";

export interface VoteSubmission {
    categorySlug: string;
    entry: string;
    securityToken?: string;
}

export interface VoteResult {
    ok: boolean;
    /** Maschinenlesbarer Fehlercode des Backends – die Seite übersetzt ihn. */
    code?: string;
    /** Nur für Logging/Debug. Immer deutsch, nie direkt anzeigen. */
    message?: string;
}

export async function submitVote(payload: VoteSubmission): Promise<VoteResult> {
    try {
        const categoryId = await resolveCategoryId(payload.categorySlug);

        await apiRequest(`/api/categories/${categoryId}/nominations`, {
            method: "POST",
            body: { text: payload.entry, securityToken: payload.securityToken },
        });

        return { ok: true };
    } catch (err) {
        return {
            ok: false,
            code: apiErrorCode(err),
            message: err instanceof Error ? err.message : undefined,
        };
    }
}